<template>
  <b-modal title="New News"
    v-model="showModal"
    @ok.prevent="submit()"
    :ok-disabled="sending || !this.formState"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form @submit.prevent>
      <b-form-group
        label="Name"
        label-for="add-news-link-name"
        invalid-feedback="Please fill out this field">
        <b-form-input
          id="add-news-link-name"
          v-model.trim="form.name"
          required
          maxlength="100"
          :state="errors.length == 0 ? null : form.name.length > 0">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Description" label-for="add-news-link-description">
        <b-form-textarea
          id="add-news-link-description" 
          v-model.trim="form.description"
          rows=3
          maxlength="500"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group label="Date" label-for="add-news-link-date">
        <!-- <b-form-input
          id="add-news-link-date"
          v-model="form.date"
          type="date"
        /> -->
        <b-form-datepicker
          id="add-news-link-date"
          v-model="form.date"
          size="sm"
          placeholder="mm/dd/yyyy"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group label="Source" label-for="add-news-link-source">
        <b-form-input
          id="add-news-link-source"
          v-model.trim="form.source"
          maxlength="100"
        />
      </b-form-group>
      <b-form-group 
        label="Url" 
        label-for="add-news-link-url"
        :invalid-feedback="urlFeedback"
      >
        <b-form-input 
          id="add-news-link-url" 
          v-model.trim="form.url"
          maxlength="2000"
          :state="errors.length == 0 ? null : urlState"
        ></b-form-input>
      </b-form-group>
      <BaseMessageBlock :messages="errors"></BaseMessageBlock>
      <template v-slot:modal-ok >
        <div style="width: 36px;" >
          <b-spinner v-if="sending" small label="Spinning"/>
          <div v-else>Add</div>
        </div>
      </template>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    newsLink: { type: Object, default: null },
    projectId: { type: String, default: '' }
  },
  data() {
    return {
      errors: [],
      showModal: false,
      sending: false,
      form: {
        name: "",
        description: "",
        date: null,
        source: "",
        url: ""
      }
    }
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    submit() {
      this.errors = [];

      if (!this.validateForm()) {
        return;
      }

      let request = {
        ...this.form,
        newsId: this.$helpers.generateUUID(),
        projectId: this.projectId
      };

      this.sending = true;

      axios
        .post(`${this.$api_url}/news-links/add`, request, this.getReqConfig())
        .then(() => {
          this.$emit("submit");
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    validateForm(){
      const initErrors = this.errors.length;
      let form = this.form;
      form.name = form.name.trim();

      if (!form.name) {
        this.errors.push({ message: 'Name cannot be empty'});
      }
      if (!form.url) {
        this.errors.push({ message: 'Url cannot be empty'});
      } else if (!this.$validate.isValidUrl(form.url)) {
        this.errors.push({ message: 'Url must be valid'});
      }


      return initErrors === this.errors.length;
    },
    resetForm() {
      this.errors = [];
      this.form = {
        name: "",
        description: "",
        date: null,
        source: "",
        url: ""
      }
    }
  },
  computed: {
    urlState() {
      return this.form.url.length > 0 && this.$validate.isValidUrl(this.form.url);
    },
    urlFeedback() {
      if (this.form.url.length === 0) {
        return "Please fill out this field"
      } else if (!this.$validate.isValidUrl(this.form.url)) {
        return "Url must be valid";
      } else {
        return "";
      }
    },
    formState() {
      return this.urlState && this.form.name.length > 0;
    }
  }
}
</script>